import { reactive } from "vue";

export const eventBus = reactive({
  isOpen: false,
  cartUpdated: 0,
  openCart() {
    this.isOpen = true;
  },
  closeCart() {
    this.isOpen = false;
  }
});